<template>
  <v-container fluid v-if="user">
    <!-- FILTROS -->
    <v-card outlined elevation="2">
      <v-card-title class="primary white--text"> Visitas/Paradas </v-card-title>

      <v-card-text>
        <v-row class="mt-4">
          <v-col cols="12" md="3">
            <v-select
              :items="usuarios.map((u) => u.nombre)"
              label="Seleccionar Usuario"
              v-model="usuarioSelected"
              dense
              outlined
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-combobox
              label="Placas"
              v-model="placas"
              :items="usuarios.map((u) => u.gps)"
              dense
              outlined
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-select
              label="Semana"
              v-model="currentWeek"
              :items="semanasOptions"
              dense
              outlined
              :hint="calcularSemana(currentWeek)"
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              class="ml-2"
              label="Año"
              v-model="currentYear"
              type="number"
              required
              dense
              outlined
            />
          </v-col>

          <v-col cols="12" md="3" class="">
            <v-btn
              color="primary"
              block
              large
              @click="obtenerParadasVehiculo()"
              :loading="loading"
            >
              BUSCAR
            </v-btn>
          </v-col>

          <v-col cols="12" md="6">
            <p>Días de la semana</p>
            <v-row>
              <v-checkbox
                v-for="dia in diasSemana"
                :key="dia"
                :label="dia"
                v-model="selectedDays"
                :value="dia"
                dense
                class="ml-2"
              />
            </v-row>
          </v-col>
          <v-col cols="12" md="3" class="mt-4">
            <v-select
              label="Duración mínima"
              v-model="selectedDuration"
              :items="durationOptions"
              dense
              class="mt-2"
            />
          </v-col>
        </v-row>
        <v-row class="mt-2">
          <v-col cols="12" md="3">
            <v-checkbox
              label="Ocultar clientes a más de 100m"
              v-model="ocultarClientes"
              dense
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-btn
              color="primary"
              @click="downloadExcel"
              :loading="loadingExcel"
              :disabled="paradas.length === 0"
              >Descargar Paradas en Excel</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- MAPA -->
    <v-row class="mt-6">
      <v-col v-if="filteredParadas.length > 0" cols="12" md="4">
        <v-card outlined elevation="2" height="700" style="overflow-y: auto">
          <v-card-title class="primary white--text"
            >Lista de Paradas</v-card-title
          >
          <v-list dense>
            <v-list-item-group v-model="selectedParadaIndex" color="primary">
              <div
                v-for="(paradasDia, dia) in filteredParadasPorDia"
                :key="'header-' + dia"
              >
                <v-subheader class="primary white--text">
                  {{ dia }}
                </v-subheader>
                <v-list-item
                  v-for="parada in paradasDia"
                  :key="parada.index"
                  @click="seleccionarParada(parada)"
                >
                  <v-list-item-avatar>
                    <v-icon color="primary">mdi-map-marker</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >Parada {{ parada.index }}</v-list-item-title
                    >
                    <v-list-item-subtitle>
                      <strong>Inicio:</strong> {{ parada.inicio }}<br />
                      <strong>Duración:</strong>
                      {{ tiempoParadoFormateado(parada.duracion) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-chip small color="blue lighten-4">{{
                      parada.index
                    }}</v-chip>
                  </v-list-item-action>
                </v-list-item>
              </div>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-col>
      <v-col :cols="12" :md="filteredParadas.length > 0 ? 8 : 12">
        <v-card outlined elevation="2" height="700">
          <gmap-map
            :center="mapCenter"
            :zoom="zoom"
            style="width: 100%; height: 100%"
            :options="{ gestureHandling: 'greedy' }"
          >
            <!-- :icon="{
            url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
          }" -->
            <!-- MARCADORES PARA PARADAS -->
            <gmap-marker
              v-for="parada in filteredParadas"
              :key="parada.index"
              :position="{ lat: parada.lat, lng: parada.lng }"
              :icon="locationGif"
              @click="abrirInfoParada(parada)"
            />

            <!-- INFO WINDOW PARA PARADAS -->
            <gmap-info-window
              v-if="infoParada"
              :position="{ lat: infoParada.lat, lng: infoParada.lng }"
              :opened="infoParadaOpen"
              @closeclick="infoParadaOpen = false"
            >
              <div class="info-window">
                <h2>Parada {{ infoParada.index }}</h2>
                <div class="d-flex justify-space-between mb-2">
                  <div>
                    <b>Nombre: {{ this.nombre }}</b>
                    <div>
                      <b>Comentario: {{ this.comentario }}</b>
                    </div>
                    <div class="caption">PLACA: {{ this.placas }}</div>
                  </div>
                </div>
                <div class="info-window">
                  Inicio: {{ infoParada.inicio }}<br />
                  Fin: {{ infoParada.fin }}<br />
                  Duración: {{ tiempoParadoFormateado(infoParada.duracion)
                  }}<br />
                </div>

                <v-divider class="my-2" />
                <div class="caption">
                  <v-icon x-small>mdi-map-marker</v-icon>
                  {{ direccion || "Obteniendo direccion..." }}
                </div>
              </div>
            </gmap-info-window>

            <!-- INFO WINDOW PARA ÁREA CLIENTE -->
            <gmap-info-window
              v-if="areaInfo"
              :position="{ lat: areaInfo.lat, lng: areaInfo.lng }"
              :opened="areaInfoOpen"
              @closeclick="areaInfoOpen = false"
            >
              <h3>Cliente: {{ areaInfo.cliente }}</h3>
              <h3>Descripción: {{ areaInfo.descripcion }}</h3>
              <div class="info-window">
                <div class="d-flex justify-space-between mb-2">
                  <div>
                    <div>
                      <b
                        >Dirección: {{ areaInfo.direccion_linea_1 }},
                        {{ areaInfo.direccion_linea_2 }}</b
                      >
                    </div>
                    <div>
                      <b>Ciudad: {{ areaInfo.ciudad }}</b>
                    </div>
                    <div>
                      <b>C.P: {{ areaInfo.codigo_postal }}</b>
                    </div>
                    <div>
                      <b>Zona: {{ areaInfo.zona }}</b>
                    </div>
                    <div>
                      <b>Notas: {{ areaInfo.notas }}</b>
                    </div>
                    <div>
                      <b>Activo: {{ areaInfo.activo ? "Sí" : "No" }}</b>
                    </div>
                    <div>
                      <b>Default: {{ areaInfo.default ? "Sí" : "No" }}</b>
                    </div>
                    <div class="caption">
                      Fecha Creación:
                      {{ formatearFecha2(areaInfo.fecha_creacion) }}
                    </div>
                  </div>
                </div>
              </div>
            </gmap-info-window>

            <!-- POLILÍNEA PARA RUTA DE PARADAS -->
            <gmap-polyline
              v-if="filteredParadas.length > 1"
              :path="rutaParadas"
              :options="polyLinesOptions"
            />

            <!-- POLÍGONO PARA ÁREA DEL CLIENTE 
            <gmap-polygon
              v-if="areaCliente.length > 2"
              :paths="areaCliente"
              :options="{
                fillColor: '#FF0000',
                fillOpacity: 0.3,
                strokeColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }"
            />
            -->

            <!-- MARCADORES PARA PUNTOS DEL ÁREA -->
            <gmap-marker
              v-for="(point, index) in areaCliente"
              :key="`area-${index}`"
              :position="{ lat: point.lat, lng: point.lng }"
              :icon="clienteGif"
              @click="seleccionarArea(point)"
            />
          </gmap-map>
        </v-card>
      </v-col>
    </v-row>

    <!-- KPIS 
    <v-row class="mt-6">
      <v-col cols="12" md="4">
        <v-card outlined class="pa-4 d-flex">
          <v-icon color="blue" large class="mr-4">trending_up</v-icon>
          <div>
            <div class="caption">Distancia Total Hoy</div>
            <div class="headline">1,248.5 km</div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card outlined class="pa-4 d-flex">
          <v-icon color="orange" large class="mr-4">local_gas_station</v-icon>
          <div>
            <div class="caption">Consumo Combustible</div>
            <div class="headline">342.2 L</div>
          </div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card outlined class="pa-4 d-flex">
          <v-icon color="primary" large class="mr-4">schedule</v-icon>
          <div>
            <div class="caption">Tiempo en Ralentí</div>
            <div class="headline">4h 12m</div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    -->
  </v-container>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import locationGif from "@/assets/locationP.gif";
import clienteGif from "@/assets/locationC.gif";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  data() {
    return {
      mapCenter: { lat: 32.62340014186072, lng: -115.46240380788693 },
      zoom: 12,
      vehicle: null, // datos del endpoint
      vehicles: [], // todos los datos
      infoWindowOpen: false,
      placas: null,
      direccion: "",
      fecha: "",
      tiempoParado: null, // tiempo que ha estado parado
      nombre: "",
      comentario: "",
      intervalId: null, // para actualización en tiempo real
      timeoutId: null, // para parar después de 5 minutos
      usuarios: [],
      usuarioSelected: null,
      loading: false,
      loadingExcel: false,
      currentWeek: moment().isoWeek(),
      currentYear: moment().year(),
      paradas: [], // paradas del vehículo
      infoParada: null,
      infoParadaOpen: false,
      tiempo: null,
      selectedParadaIndex: null,
      areaData: [], // datos del área del cliente desde el endpoint
      areaInfo: null,
      areaInfoOpen: false,
      polyLinesOptions: null,
      selectedDays: [], // días seleccionados para filtrar
      diasSemana: [
        "lunes",
        "martes",
        "miércoles",
        "jueves",
        "viernes",
        "sábado",
      ],
      selectedDuration: null, // duración mínima seleccionada en minutos
      durationOptions: [
        { text: "Todas las duraciones", value: null },
        { text: "1 minuto o más", value: 1 },
        { text: "2 minutos o más", value: 2 },
        { text: "3 minutos o más", value: 3 },
        { text: "4 minutos o más", value: 4 },
        { text: "5 minutos o más", value: 5 },
        { text: "10 minutos o más", value: 10 },
        { text: "15 minutos o más", value: 15 },
        { text: "30 minutos o más", value: 30 },
        { text: "1 hora o más", value: 60 },
        { text: "2 horas o más", value: 120 },
      ],
      ocultarClientes: false, // ocultar clientes a más de 100 metros
    };
  },
  methods: {
    async obtenerParadasVehiculo() {
      if (this.placas === null || this.placas === "") {
        alert("Por favor ingrese las placas del vehículo.");
        return;
      }
      try {
        this.loading = true;
        const response = await axios.get(
          `/gps/get_paradas_de_vehiculo?placas=${this.placas}&semana=${this.currentWeek}&year=${this.currentYear}`,
        );

        this.nombre = response.data.nombre || "";
        this.comentario = response.data.comentario || "";

        // Procesar paradas
        if (response.data.paradas) {
          this.paradas = response.data.paradas.data.map((p, i) => ({
            index: response.data.paradas.index[i],
            inicio: moment.unix(p[0]).format("DD/MM/YYYY HH:mm"),
            fin: moment.unix(p[1]).format("DD/MM/YYYY HH:mm"),
            lat: p[2],
            lng: p[3],
            duracion: p[4],
          }));
        }

        // Si hay paradas, centrar mapa en la primera
        if (this.paradas.length > 0) {
          this.mapCenter = {
            lat: this.paradas[0].lat,
            lng: this.paradas[0].lng,
          };
          this.zoom = 14;
        }

        this.direccion = await this.ObtenerDireccion(
          this.mapCenter.lat,
          this.mapCenter.lng,
        );

        // Calcular min/max de las paradas para el área
        if (this.paradas.length > 0) {
          const lngs = this.paradas.map((p) => p.lng);
          const lats = this.paradas.map((p) => p.lat);
          const minLng = Math.min(...lngs);
          const maxLng = Math.max(...lngs);
          const minLat = Math.min(...lats);
          const maxLat = Math.max(...lats);

          // Obtener el área del cliente con min/max
          await this.obtenerLocalizacionArea(minLat, maxLat, minLng, maxLng);
        } else {
          this.areaData = [];
        }

        if (this.paradas.length > 1) {
          await this.crearFlechasEnPolylines();
        }

        this.updateArea();

        this.loading = false;
      } catch (error) {
        if (error.response.status == 404) {
          alert(
            "No se encontraron paradas para la placa y/o semana seleccionada.",
          );
        } else {
          alert("Error al obtener las paradas del vehículo.");
        }
        this.loading = false;
        console.error("Error al obtener las paradas del vehículo:", error);
      }
    },

    async ObtenerDireccion(lat, lng) {
      await this.$gmapApiPromiseLazy();

      return new Promise((resolve, reject) => {
        const geocoder = new window.google.maps.Geocoder();
        const latlng = { lat: parseFloat(lat), lng: parseFloat(lng) };
        geocoder.geocode({ location: latlng }, (results, status) => {
          if (status === "OK") {
            if (results[0]) {
              resolve(results[0].formatted_address);
            } else {
              resolve("No se encontraron resultados");
            }
          } else {
            reject("Error en la geocodificación: " + status);
          }
        });
      });
    },

    async crearFlechasEnPolylines() {
      {
        await this.$gmapApiPromiseLazy();

        if (!window.google) {
          console.error("Google Maps no está cargado");
          return;
        }

        this.polyLinesOptions = {
          strokeColor: "#377EE6",
          strokeOpacity: 0.8,
          strokeWeight: 4,
          icons: [
            {
              icon: {
                path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                scale: 3,
                strokeColor: "#2D528C",
              },
              offset: "100%",
              repeat: "100px",
            },
          ],
        };
      }
    },

    abrirGoogleMaps() {
      if (this.direccion) {
        const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          this.direccion,
        )}`;
        window.open(url, "_blank");
      }
    },

    async obtenerLocalizacionArea(minLat, maxLat, minLng, maxLng) {
      try {
        const response = await axios.get(
          `/gps/get_localizaciones_en_area?longitud_min=${minLng}&longitud_max=${maxLng}&latitud_min=${minLat}&latitud_max=${maxLat}`,
        );
        // Normalizar los datos del área
        let area = response.data || [];
        //console.log("Datos crudos del endpoint:", area);
        if (Array.isArray(area) && area.length > 0) {
          this.areaData = area
            .map((point) => {
              //console.log(`Procesando punto ${index}:`, point);
              if (Array.isArray(point)) {
                // Si es [lat, lng]
                const lat = parseFloat(point[0]);
                const lng = parseFloat(point[1]);
                //console.log(`Convertido a {lat: ${lat}, lng: ${lng}}`);
                return { lat, lng };
              } else if (
                point &&
                point.latitud !== undefined &&
                point.longitud !== undefined
              ) {
                // Si es objeto con latitud/longitud
                const lat = parseFloat(point.latitud);
                const lng = parseFloat(point.longitud);
                //console.log(`Convertido a {lat: ${lat}, lng: ${lng}}`);
                return { ...point, lat, lng };
              } else if (
                point &&
                point.lat !== undefined &&
                point.lng !== undefined
              ) {
                // Si ya es {lat, lng}
                const lat = parseFloat(point.lat);
                const lng = parseFloat(point.lng);
                //console.log(`Convertido a {lat: ${lat}, lng: ${lng}}`);
                return { lat, lng };
              }
              //console.log("Punto inválido, retornando null");
              return null;
            })
            .filter((p) => {
              const valid = p && !isNaN(p.lat) && !isNaN(p.lng);
              //console.log("Filtrando punto:", p, "válido:", valid);
              return valid;
            });
          //console.log("Después del map y filter:", this.areaData);
          /* Cerrar el polígono si no está cerrado
          if (
            this.areaData.length > 2 &&
            (this.areaData[0].lat !==
              this.areaData[this.areaData.length - 1].lat ||
              this.areaData[0].lng !==
                this.areaData[this.areaData.length - 1].lng)
          ) {
            this.areaData.push(this.areaData[0]);
            console.log("Polígono cerrado, puntos finales:", this.areaData);
          }*/
        } else {
          this.areaData = [];
        }
      } catch (error) {
        console.error("Error obteniendo área:", error);
        this.areaData = [];
      }
    },
    //metodo para obtener la longitud y latitud minima y maxima de las paradas filtradas
    updateArea() {
      if (this.filteredParadas.length > 0) {
        const lngs = this.filteredParadas.map((p) => p.lng);
        const lats = this.filteredParadas.map((p) => p.lat);
        const minLng = Math.min(...lngs);
        const maxLng = Math.max(...lngs);
        const minLat = Math.min(...lats);
        const maxLat = Math.max(...lats);

        this.obtenerLocalizacionArea(minLat, maxLat, minLng, maxLng);
      } else {
        this.areaData = [];
      }
    },

    distancia(lat1, lng1, lat2, lng2) {
      // Fórmula de Haversine para calcular distancia en metros
      //Haversine: metodo trigonometrico para calcular la distancia mas corta entre dos puntos en una esfera usando coordenadas de latitud y longitud

      const R = 6371000; // Radio de la Tierra en metros
      const dLat = ((lat2 - lat1) * Math.PI) / 180;
      const dLng = ((lng2 - lng1) * Math.PI) / 180;
      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos((lat1 * Math.PI) / 180) *
          Math.cos((lat2 * Math.PI) / 180) *
          Math.sin(dLng / 2) *
          Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    },

    con100metros(point, paradas) {
      return paradas.some(
        (p) => this.distancia(p.lat, p.lng, point.lat, point.lng) <= 100,
      );
    },

    formatearFecha(fecha) {
      const dateTime = moment(Number(fecha)).format("DD/MM/YYYY ");
      return dateTime;
    },
    formatearFecha2(fecha) {
      const dateTime = moment(fecha).format("DD/MM/YYYY ");
      return dateTime;
    },
    abrirInfoParada(parada) {
      this.infoParada = parada;
      this.infoParadaOpen = true;
    },
    seleccionarParada(parada) {
      this.infoParada = parada;
      this.infoParadaOpen = true;
      this.selectedParadaIndex = this.filteredParadas.indexOf(parada);
      // Opcional: centrar mapa en la parada seleccionada
      this.mapCenter = { lat: parada.lat, lng: parada.lng };
    },

    seleccionarArea(areaPoint) {
      this.areaInfo = areaPoint;
      this.areaInfoOpen = true;
    },

    calcularSemana(semana) {
      if (!semana || !this.currentYear) return "";
      const año = this.currentYear;
      const SemanaAño = moment().year(año).isoWeek(semana).startOf("isoWeek");
      const inicioSemana = SemanaAño.format("DD-MM-YYYY");
      const finSemana = SemanaAño.add(6, "days").format("DD-MM-YYYY");
      return `Desde ${inicioSemana} a ${finSemana}`;
    },

    async getUsuarios() {
      try {
        const usuarios = await axios.get("/usuarios/get_usuarios");
        //filtrar a los usuarios solo con gps
        this.usuarios = usuarios.data.usuarios.filter(
          (usuario) => usuario.gps !== null && usuario.gps !== "",
        );
      } catch (error) {
        console.error(error);
      }
    },
    tiempoParadoFormateado(seconds) {
      if (!seconds) return "";
      const duration = moment.duration(seconds, "seconds");
      const days = Math.floor(duration.asDays());
      const hours = Math.floor(duration.asHours()) % 24;
      const minutes = Math.floor(duration.asMinutes()) % 60;
      let str = "";
      if (days > 0) str += `${days} días `;
      if (hours > 0) str += `${hours} horas `;
      if (minutes > 0 || str === "") str += `${minutes} minutos`;
      return str.trim();
    },

    async downloadExcel() {
      if (this.filteredParadas.length === 0) {
        alert("No hay paradas para exportar");
        return;
      }

      this.loadingExcel = true;

      try {
        const rows = [];

        // Obtener direcciones y crear filas
        for (const p of this.filteredParadas) {
          let direccion = "Sin dirección";

          try {
            direccion = await this.ObtenerDireccion(p.lat, p.lng);
          } catch (e) {
            console.warn("No se pudo obtener dirección:", e);
          }

          rows.push({
            Usuario: this.usuarioSelected || this.nombre || "N/A",
            Placas: this.placas,
            "Parada #": p.index,
            "Fecha Inicio": p.inicio,
            "Fecha Fin": p.fin,
            Duración: this.tiempoParadoFormateado(p.duracion),
            Latitud: p.lat,
            Longitud: p.lng,
            Dirección: direccion,
          });
        }

        // Crear hoja de excel
        const worksheet = XLSX.utils.json_to_sheet(rows);

        // Convertir columna Dirección en link directo, sin formulas
        rows.forEach((row, index) => {
          const cellRef = `I${index + 2}`;

          if (worksheet[cellRef]) {
            worksheet[cellRef].l = {
              Target: `https://www.google.com/maps?q=${row.Latitud},${row.Longitud}`,
              Tooltip: "Abrir en Google Maps",
            };
          }
        });

        // Crear libro
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Paradas");

        // Generar archivo
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });

        const blob = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileName = `Paradas: ${this.usuarioSelected} - ${this.placas}_Semana${this.currentWeek}_${this.currentYear}.xlsx`;

        saveAs(blob, fileName);
      } catch (error) {
        console.error("Error al generar Excel:", error);
        alert("Error al generar el archivo Excel");
      } finally {
        this.loadingExcel = false;
      }
    },
  },
  computed: {
    ...mapGetters(["user"]),
    markerPosition() {
      if (!this.vehicle) return null;
      return {
        lat: Number(this.vehicle.latitude),
        lng: Number(this.vehicle.longitude),
      };
    },

    locationGif() {
      return {
        url: locationGif,
        scaledSize: { width: 40, height: 40 },
        anchor: { x: 20, y: 20 },
      };
    },

    clienteGif() {
      return {
        url: clienteGif,
        scaledSize: { width: 40, height: 40 },
        anchor: { x: 20, y: 20 },
      };
    },

    path() {
      return this.vehicles.map((v) => ({
        lat: Number(v.latitude),
        lng: Number(v.longitude),
      }));
    },

    semanasOptions() {
      const semanas = [];
      const totalSemanas = moment().year(this.currentYear).isoWeeksInYear();
      for (let i = 1; i <= totalSemanas; i++) {
        semanas.push({ text: `${i}`, value: i });
      }
      return semanas;
    },

    rutaParadas() {
      return this.filteredParadas.map((p) => ({ lat: p.lat, lng: p.lng }));
    },

    areaCliente() {
      // Usar los datos del endpoint en lugar de calcular bounding box
      let clients = this.areaData;
      if (this.ocultarClientes) {
        clients = clients.filter((point) =>
          this.con100metros(point, this.filteredParadas),
        );
      }
      return clients;
    },

    paradasPorDia() {
      const grouped = {};
      this.paradas.forEach((p) => {
        const date = moment(p.inicio, "DD/MM/YYYY HH:mm");
        const day = date.locale("es").format("dddd"); // e.g., "lunes"
        if (!grouped[day]) grouped[day] = [];
        grouped[day].push(p);
      });
      return grouped;
    },

    filteredParadas() {
      return this.paradas.filter((p) => {
        const date = moment(p.inicio, "DD/MM/YYYY HH:mm");
        const day = date.locale("es").format("dddd");
        //filtro para mostrar los datos del dia o dias seleccionados
        const dayFilter =
          this.selectedDays.length === 0 || this.selectedDays.includes(day);
        //filtro para mostrar los datos con duracion seleccionada
        const durationFilter =
          !this.selectedDuration || p.duracion >= this.selectedDuration * 60;
        return dayFilter && durationFilter;
      });
    },

    filteredParadasPorDia() {
      const grouped = {};
      this.filteredParadas.forEach((p) => {
        const date = moment(p.inicio, "DD/MM/YYYY HH:mm");
        const day = date.locale("es").format("dddd");
        if (!grouped[day]) grouped[day] = [];
        grouped[day].push(p);
      });
      return grouped;
    },
  },

  created() {
    this.getUsuarios();
  },
  watch: {
    usuarioSelected(newVal) {
      const usuario = this.usuarios.find((u) => u.nombre === newVal);
      if (usuario) {
        this.placas = usuario.gps;
      }
    },
    placas(newVal) {
      const usuario = this.usuarios.find((u) => u.gps === newVal);
      if (usuario) {
        this.usuarioSelected = usuario.nombre;
      }
    },
    currentYear() {
      // Si cambia el año, ajustar la semana si es mayor que el total de semanas del año
      const totalSemanas = moment().year(this.currentYear).isoWeeksInYear();
      if (this.currentWeek > totalSemanas) {
        this.currentWeek = totalSemanas;
      }
    },
    //metodos para actualizar el mapa del area del cliente
    selectedDays() {
      this.updateArea();
    },
    selectedDuration() {
      this.updateArea();
    },
  },
};
</script>

<style scoped>
.map-pin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -100%);
  background: #00bfa5;
  border-radius: 50%;
  padding: 10px;
}

.map-info {
  position: absolute;
  top: 60%;
  left: 50%;
  transform: translateX(-50%);
  width: 260px;
}
</style>
